import React from 'react';

import './Signup.css';
import { useDispatch, useSelector } from 'react-redux';
import { changeSignupAdminName, changeSignupAdminPassword, changeSignupAdminUserId, changeSignupBankName, isSigningUp, selectSignupAdminName, selectSignupAdminPassword, selectSignupAdminUserId, selectSignupBankName, signup } from './signupSlice';
import { Navigate } from 'react-router-dom';
import { isLoggedIn } from '../login/loginSlice';

export default function SignUp() {
    const dispatch = useDispatch();

    const signupAdminUserId = useSelector(selectSignupAdminUserId);
    const signupAdminName = useSelector(selectSignupAdminName);
    const signupAdminPassword = useSelector(selectSignupAdminPassword);
    const signupBankName = useSelector(selectSignupBankName);
    const signingUp = useSelector(isSigningUp);
    const loggedIn = useSelector(isLoggedIn);

    const handleSignupAdminUserIdChange = (event) => {
        const newAdminUserId = event.target.value;
        dispatch(changeSignupAdminUserId(newAdminUserId));
    }

    const handleSignupAdminNameChange = event => {
        const newAdminName = event.target.value;
        dispatch(changeSignupAdminName(newAdminName));
    }

    const handleSignupAdminPasswordChange = (event) => {
        const newAdminPassword = event.target.value;
        dispatch(changeSignupAdminPassword(newAdminPassword));
    }

    const handleSignupBankNameChange = (event) => {
        const newBankName = event.target.value;
        dispatch(changeSignupBankName(newBankName));
    }

    const handleSubmit = async (event) => {
        event.preventDefault();
        const newBankInfo = {
            bankName: signupBankName
        }
        const newAdminInfo = {
            username: signupAdminUserId,
            name: signupAdminName,
            password: signupAdminPassword,
            userRole: 'ADMIN'
        }
        dispatch(signup({newBankInfo, newAdminInfo}))
    }
    
    if (loggedIn) {
        return <Navigate replace to={"/home"} />;
    } else {    
        return (
            <main className='signup'>
                <h1>Sign Up</h1>
                <section className='admin-settings'>
                    <h2>Create your admin credentials</h2>
                    <form onSubmit={handleSubmit}>
                        <label htmlFor='userId'>
                            <p>User Id:</p>
                            <input name='userId' onChange={handleSignupAdminUserIdChange} value={signupAdminUserId}></input>
                        </label>
                        <label htmlFor='admin-name'>
                            <p>Admin/Teacher Name:</p>
                            <input name='admin-name' onChange={handleSignupAdminNameChange} value={signupAdminName}></input>
                        </label>
                        <label htmlFor='password'>
                            <p>Password:</p>
                            <input name='password' type='password' onChange={handleSignupAdminPasswordChange} value={signupAdminPassword}></input>
                        </label>
                        <label htmlFor='bank-name'>
                            <p>Bank Name:</p>
                            <input name='bank-name' onChange={handleSignupBankNameChange} value={signupBankName}></input>
                            <h4>*You can change the bank name later</h4>
                        </label>
                        <button type='submit' disabled={signingUp}>{signingUp ? 'Signing Up' : 'Submit'}</button>
                    </form>
                </section>
            </main>
        )
    }
}